import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './InquiryForm.css';

const InquiryForm = () => {
     const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        inquiryType: '',
        comment: '',
    });

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const serviceID = 'service_qv7pbs9';
        const templateID = 'template_03wlhoz';
        const userID = 'K6RpAfOPBujJP3eHE';

        emailjs.send(serviceID, templateID, formData, userID)
        .then(() => {
            navigate('/confirmation'); // 🔁 Redirect on success
        })
        .catch(() => {
            alert('Failed to send. Please try again.');
        });
    };

    return (
        <div className="inquiry-container">
        <form onSubmit={handleSubmit} className="inquiry-form">
            <label>Your Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />

            <label>Your Email:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />

            <label>What Would You Like to Capture?</label>
            <select name="inquiryType" value={formData.inquiryType} onChange={handleChange} required>
            <option value="" disabled>Select an Option</option>
            <option value="car">Car</option>
            <option value="motorsport">Motorsport</option>
            <option value="event">Event</option>
            <option value="sport">Sport</option>
            <option value="portrait">Portrait</option>
            </select>
            <label>Short Description:</label>
            <textarea name="comment" value={formData.comment} onChange={handleChange} rows="4" required />
            <button type="submit">Send Inquiry</button>
        </form>
        </div>
    );
    };

export default InquiryForm;
